import { BaseContext } from '../../../../utils/basecontext';
import { UploadKaroakeRequestImpl } from '../../../../core/api/karoake/uploadkaroake/uploadkaroakerequest';
import { UploadKaroakeResponse } from '../../../../core/api/karoake/uploadkaroake/uploadkaroakeresponse';
import { UploadKaroakeDtoImpl, UploadKaroakeDto } from '../../../../core/dto/uploadkaroake/uploadkaroakedto';
import { APIModel, APIModelHandler, APIModelImpl } from '../../../toolkit/uicomponentapimodel';
import { DoItYourselfComponent } from './doityourselfcomponent';

export interface DoItYourselfAPIModel extends APIModel
{
    getDoItYourself(uploadKaroakeDto: UploadKaroakeDto): void;
}

export class DoItYourselfAPIModelImpl extends APIModelImpl implements DoItYourselfAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    getDoItYourself(uploadKaroakeDto: UploadKaroakeDtoImpl): void
    {
        console.log("getDoItYourself() invoked");
     
        uploadKaroakeDto.setServiceId("4");
        uploadKaroakeDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        uploadKaroakeDto.setIscopy("T");
        uploadKaroakeDto.setChannelId(this.getContext().getUserContext().getChannelId());
        uploadKaroakeDto.setLanguage(this.getContext().getUserContext().getLanguage());
        uploadKaroakeDto.setPriority("0");

        this.getAPIProcesssorFactory().getKaroakeProcessorFactory().getUploadKaroakeDetails()
        .success((uploadKaroakeResponse: UploadKaroakeResponse)=>
        {
            this.getAPIModelHandler().onSuccess(uploadKaroakeResponse.getAPIFeature(), 
            uploadKaroakeResponse.getDescription(), uploadKaroakeResponse);
          
         })
        .failure((uploadKaroakeResponse: UploadKaroakeResponse)=>
         {
           this.getAPIModelHandler().onFailure(uploadKaroakeResponse.getAPIFeature(), 
           uploadKaroakeResponse.getDescription(), undefined);
         })
         .uploadProgress((percentage: number) =>
         {
            console.log("--------uploadpercentage: " + percentage);

            (this.getAPIModelHandler() as DoItYourselfComponent).setUploadProgress(percentage);
         })
        .execute(new UploadKaroakeRequestImpl(uploadKaroakeDto));
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/doityourself/doityourselfapimodel.ts